import { MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE } from '@modules/whitelabel-cover-page/marketing-page-section/marketing-page-section.constants';

export const PINNED_HORIZONTAL_SCROLL_LAYOUT_FIELD_KEYS = {
  SECTION_HEADING: 'section_heading',
  SECTION_SUBHEADING: 'subheading',
  CARDS: 'pinned_horizontal_cards',
  CARD_IMAGE: 'image',
  CARD_TITLE: 'title',
  CARD_SUBTITLE: 'subtitle',
  CARD_CTA_LABEL: 'cta_label',
  CARD_CTA_REDIRECTION_URL: 'cta_redirection_url'
} as const;

export const PINNED_HORIZONTAL_SCROLL_LAYOUT_CONSTANTS = {
  LAYOUT_LABEL: 'Scroll-Driven Card Rail',
  LAYOUT_DESCRIPTION:
    'Sticky horizontal card rail that advances as the user scrolls down the page',
  LAYOUT_IMAGE_PATH: 'https://cdn-www.topfans.com/TopFans/1785500078423.png',
  LABEL_SECTION_HEADING: 'Heading',
  PLACEHOLDER_SECTION_HEADING: 'Enter heading',
  LABEL_SECTION_SUBHEADING: 'Subheading',
  PLACEHOLDER_SECTION_SUBHEADING: 'Enter subheading',
  INFO_HEADING_HIGHLIGHT: MARKETING_SECTION_HEADING_HIGHLIGHT_INFO_MESSAGE,
  LABEL_CARD_COLLECTION: 'Pinned cards',
  LABEL_CARD_PREFIX: 'Card',
  LABEL_CARD_IMAGE: 'Image',
  LABEL_CARD_TITLE: 'Title',
  LABEL_CARD_SUBTITLE: 'Subtitle',
  LABEL_CARD_CTA_LABEL: 'CTA Label',
  LABEL_CARD_CTA_REDIRECTION_URL: 'CTA Redirection URL',
  PLACEHOLDER_CARD_TITLE: 'Enter title',
  PLACEHOLDER_CARD_SUBTITLE: 'Enter subtitle',
  PLACEHOLDER_CARD_CTA_LABEL: 'Enter CTA label',
  PLACEHOLDER_CARD_CTA_REDIRECTION_URL: 'https://... or /internal-path',
  LABEL_ADD_CARD: 'Add card',
  LABEL_REMOVE_CARD: 'Remove card',
  BANNER_IMAGE_TITLE: 'Add Image',
  BANNER_IMAGE_LABEL: 'SELECT FILE',
  PLACEHOLDER_HEADING: 'Section Heading',
  DEFAULT_BACKGROUND_COLOR: '#f7f0de',
  DEFAULT_THEME_COLOR: '#c83c7a',
  DEFAULT_SECONDARY_BACKGROUND_COLOR: '#ffffff',
  DEFAULT_POST_TEXT_COLOR: '#5b4b45',
  DEFAULT_BACKGROUND_TEXT_COLOR: '#221b18',
  DEFAULT_BUTTON_TEXT_COLOR: '#ffffff',
  DEFAULT_CARD_TITLE: 'Card title',
  DEFAULT_CARD_SUBTITLE: 'Card subtitle',
  DEFAULT_CARD_CTA_LABEL: 'Learn more',
  DEFAULT_CARD_IMAGE_ALT: 'Pinned horizontal card image',
  EMPTY_CARDS_MESSAGE: 'Add cards in the editor to preview this section.',
  EXTERNAL_LINK_REL_ANCHOR: 'noopener,noreferrer',
  CARD_IMAGE_WIDTH_PX: 1152,
  CARD_IMAGE_HEIGHT_PX: 504,
  BASE_CARD_SCALE: 1,
  RAIL_OFFSET_LERP_FACTOR: 0.12,
  CARD_DISTANCE_SCALE_DELTA: 0.2,
  CARD_DISTANCE_OPACITY_DELTA: 0.6,
  CARD_DISTANCE_OPACITY_FLOOR: 0.4,
  RAIL_TRACK_TRANSLATE_3D_PREFIX: 'translate3d(-',
  RAIL_TRACK_TRANSLATE_3D_SUFFIX: 'px, 0, 0)',
  CARD_INNER_SCALE_TRANSFORM_PREFIX: 'scale(',
  CARD_INNER_SCALE_TRANSFORM_SUFFIX: ')',
  CARD_CTA_DEFAULT_HREF: '#',
  BLANK_WINDOW_TARGET: '_blank',
  CARD_CTA_LINK_REL_EXTERNAL: 'noopener',
  CARD_CTA_ARROW_SVG_XMLNS: 'http://www.w3.org/2000/svg',
  CARD_CTA_ARROW_VIEW_BOX: '0 0 23 23',
  CARD_CTA_ARROW_WIDTH_PX: 24,
  CARD_CTA_ARROW_HEIGHT_PX: 24,
  CARD_CTA_ARROW_FILL_NONE: 'none',
  CARD_CTA_ARROW_FILL_CURRENT_COLOR: 'currentColor',
  CARD_CTA_ARROW_PATH_D:
    'M11.2734 0C5.0505 0 0 5.0505 0 11.2734C0 17.4964 5.0505 22.5469 11.2734 22.5469C17.4964 22.5469 22.5469 17.4964 22.5469 11.2734C22.5469 5.0505 17.4964 0 11.2734 0ZM15.8166 11.8709L12.4346 15.253C12.2655 15.4221 12.0513 15.501 11.8371 15.501C11.6229 15.501 11.4087 15.4221 11.2396 15.253C10.9127 14.926 10.9127 14.3849 11.2396 14.058L13.1786 12.1189H7.32773C6.86552 12.1189 6.48223 11.7356 6.48223 11.2734C6.48223 10.8112 6.86552 10.4279 7.32773 10.4279H13.1786L11.2396 8.4889C10.9127 8.16197 10.9127 7.62084 11.2396 7.29391C11.5665 6.96698 12.1077 6.96698 12.4346 7.29391L15.8166 10.6759C16.1436 11.0029 16.1436 11.544 15.8166 11.8709Z'
} as const;

/** Used only to detect identical rail geometry across redundant measures. */
export const PINNED_HORIZONTAL_SCROLL_SNAP_LAYOUT_SIGNATURE_PART_SEPARATOR = '|';
export const PINNED_HORIZONTAL_SCROLL_SNAP_LAYOUT_SNAP_SEPARATOR = ':';

export type PinnedHorizontalScrollCardFieldKey =
  (typeof PINNED_HORIZONTAL_SCROLL_LAYOUT_FIELD_KEYS)[
    | 'CARD_IMAGE'
    | 'CARD_TITLE'
    | 'CARD_SUBTITLE'
    | 'CARD_CTA_LABEL'
    | 'CARD_CTA_REDIRECTION_URL'];

export function getPinnedHorizontalScrollCardFieldName(
  index: number,
  fieldKey: PinnedHorizontalScrollCardFieldKey
): string {
  return `pinned_horizontal_${index}_${fieldKey}`;
}
